import { BUNDLE_USAGE_TRESHOLDS } from 'modules/billing/constants';
import { IProgressBarProps } from 'modules/common/components/ProgressBar';

export const getColor = (left: number): IProgressBarProps['color'] => {
  if (left < BUNDLE_USAGE_TRESHOLDS.error) {
    return 'error';
  }

  if (left < BUNDLE_USAGE_TRESHOLDS.warning) {
    return 'warning';
  }

  return undefined;
};
